import { Maybe, SortDirection } from '@neo.tax/shared/graphql';
import { FilterSortDataType } from '@neo.tax/shared/utils';

export interface SortDirectionDropdownMenuProps {
  dataType: FilterSortDataType;
  value: Maybe<SortDirection>;
  onChange: (value: SortDirection) => void;
}

export enum SortDirectionTitle {
  ASC_NUMERIC = '1 ➜ 9',
  DESC_NUMERIC = '9 ➜ 1',
  ASC_ALPHABETICAL = 'A ➜ Z',
  DESC_ALPHABETICAL = 'Z ➜ A',
  ASC_RELEVANCE = 'Low ➜ High',
  DESC_RELEVANCE = 'High ➜ Low',
  ASC_BOOLEAN = 'No ➜ Yes',
  DESC_BOOLEAN = 'Yes ➜ No',
}

interface SortDropdownMenuProps {
  options: SortDirectionTitle[];
  value: SortDirectionTitle | null;
  onChange: (value: SortDirectionTitle) => void;
}

const getSortDropdownMenuProps = ({
  onChange,
  options,
  value,
}: {
  options: SortDirectionTitle[];
} & Pick<SortDirectionDropdownMenuProps, 'onChange' | 'value'>): SortDropdownMenuProps => {
  const [ascOption, descOption] = options;
  const title = value === SortDirection.Desc ? descOption : ascOption;
  return {
    options,
    value: value ? title : null,
    onChange: (value: SortDirectionTitle): void => {
      const newValue = value === ascOption ? SortDirection.Asc : SortDirection.Desc;
      onChange(newValue);
    },
  };
};

export const useSortDirectionDropdownMenu = ({
  dataType,
  onChange,
  value,
}: SortDirectionDropdownMenuProps): SortDropdownMenuProps => {
  if (dataType === FilterSortDataType.NUMBER) {
    const options = [SortDirectionTitle.ASC_NUMERIC, SortDirectionTitle.DESC_NUMERIC];
    return getSortDropdownMenuProps({ options, onChange, value });
  }
  if (dataType === FilterSortDataType.RELEVANCE) {
    const options = [SortDirectionTitle.ASC_RELEVANCE, SortDirectionTitle.DESC_RELEVANCE];
    return getSortDropdownMenuProps({ options, onChange, value });
  }
  if (dataType === FilterSortDataType.BOOLEAN) {
    const options = [SortDirectionTitle.ASC_BOOLEAN, SortDirectionTitle.DESC_BOOLEAN];
    return getSortDropdownMenuProps({ options, onChange, value });
  }
  const options = [SortDirectionTitle.ASC_ALPHABETICAL, SortDirectionTitle.DESC_ALPHABETICAL];
  return getSortDropdownMenuProps({ options, onChange, value });
};
